import React, { useEffect, useState } from "react";
import {
  server_post_data,
  maintainance_car_data,
  repairing_car_data,
} from "../../ServiceConnection/serviceconnection";
import { handleError } from "../../CommonJquery/CommonJquery";

const GeneralInfoRepair = ({
  onNext,
  onBack,
  MaintainanceData,
  setCount,
  cardata,
  BookingData,
  FromComeData,
  onReasonChange,
}) => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [generalInfoData, setGeneralInfoData] = useState({
    reason: "Repair",
    doneBy: "",
    otherSpecify: "",
    issue: "",
  });
  const [errors, setErrors] = useState({});

  const staffdata = [
    "roberto",
    "dar",
    "marcus",
    "kumar",
    "cheema",
    "stephan",
    "driver",
    "other",
  ];

  useEffect(() => {
    const staffName = MaintainanceData?.assign_staff_name || "";

    if (staffName === "") {
      setGeneralInfoData({
        reason: MaintainanceData?.maintenance_reasion || "",
        doneBy: "",
        otherSpecify: "",
        issue: MaintainanceData?.name_and_issue || "",
      });
    } else {
      const isMatched = staffdata.includes(staffName.toLowerCase());
      setGeneralInfoData({
        reason: MaintainanceData?.maintenance_reasion || "",
        doneBy: isMatched ? staffName : "other",
        otherSpecify: isMatched ? "" : staffName,
        issue: MaintainanceData?.name_and_issue || "",
      });
    }
  }, [MaintainanceData]);

  //console.log("GeneralInfoData", generalInfoData);

  const handleNext = async () => {
    const newErrors = {};

    // if (!generalInfoData.reason) newErrors.reason = "Please fill this field.";
    if (!generalInfoData.doneBy) newErrors.doneBy = "Please fill this field.";
    if (generalInfoData.doneBy === "other" && !generalInfoData.otherSpecify) {
      newErrors.otherSpecify = "Please specify.";
    }
    if (!generalInfoData.issue) newErrors.issue = "Please fill this field.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      //console.log("Saved Data:", generalInfoData.doneBy);
      setshowLoaderAdmin(true);

      const fd = new FormData();
      fd.append("car_id", cardata.primary_id);
      fd.append("user_id", BookingData?.user_id || 0);
      fd.append("booking_id", BookingData?.primary_id || 0);
      fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
      fd.append("date", cardata.next_maintenance_date);
      fd.append("licence_plate", cardata.car_no);
      fd.append("repairing_reason", generalInfoData.reason);
      if (
        generalInfoData.otherSpecify !== "" &&
        generalInfoData.otherSpecify !== undefined &&
        generalInfoData.doneBy === "other"
      ) {
        fd.append("assign_staff_name", generalInfoData.otherSpecify);
      } else {
        fd.append("assign_staff_name", String(generalInfoData.doneBy));
      }
      fd.append("name_and_issue", generalInfoData.issue);
      fd.append("step_for_repairing", 0);
      fd.append("save_or_edit_type", FromComeData);
      await server_post_data(repairing_car_data, fd)
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            // console.log(Response.data.message);
            setCount(1);

            // Notify parent component about the reason change
            if (onReasonChange) {
              onReasonChange(generalInfoData.reason);
            }

            onNext();
          }
          setshowLoaderAdmin(false);
        })
        .catch((error) => {
          handleError("network");
          setshowLoaderAdmin(false);
        });
    }
  };

  const handleChange = (field, value) => {
    setGeneralInfoData({ ...generalInfoData, [field]: value });
    setErrors({ ...errors, [field]: "" });

    // If reason is changed, notify parent immediately
    if (field === "reason" && onReasonChange) {
      onReasonChange(value);
    }
  };

  return (
    <>
      <div className="general-info-container">
        <div className="section">
          <h5 className="section_title">
            Done By <span className="mandory_field">*</span>
          </h5>
          <div className="row">
            {staffdata.map((item) => (
              <div className="col-md-3 mb-2" key={item}>
                <button
                  className={`btn_all w-100 ${
                    generalInfoData.doneBy === item ? "active" : ""
                  }`}
                  onClick={() => handleChange("doneBy", item)}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </button>
              </div>
            ))}
          </div>
          {errors.doneBy && <span className="error-text">{errors.doneBy}</span>}

          {generalInfoData.doneBy === "other" && (
            <div className="col-md-6 mb-3">
              <h5 className="section_title">Please specify </h5>
              <input
                type="text"
                className="form-control othr_chrck_input"
                placeholder="Enter details here..."
                maxLength={250}
                defaultValue={generalInfoData.otherSpecify}
                onChange={(e) => handleChange("otherSpecify", e.target.value)}
              />
              {errors.otherSpecify && (
                <span className="error-text">{errors.otherSpecify}</span>
              )}
            </div>
          )}
        </div>

        <div className="section">
          <h5 className="section_title">
            Issue with the car <span className="mandory_field">*</span>
          </h5>
          <div className="row">
            <div className="col-12">
              <textarea
                className="input_all"
                rows="4"
                placeholder="Please Specify the Issue of the Car"
                value={generalInfoData.issue}
                onChange={(e) => handleChange("issue", e.target.value)}
              ></textarea>
              {errors.issue && (
                <span className="error-text">{errors.issue}</span>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="navigation-buttons">
        <button className="btn back-button firstbackBtn" onClick={onBack}>
          Back
        </button>

        <button className="btn next__button" onClick={handleNext}>
          Next
        </button>
      </div>
    </>
  );
};

export default GeneralInfoRepair;
